"use client";

import { useId } from "react";

interface Props {
  className?: string;
  height?: number;
  variant?: "color" | "light";
}

export function FitoLogo({ className, height = 36, variant = "color" }: Props) {
  const gradId = useId();
  const stops =
    variant === "light"
      ? { from: "#7eb6ff", to: "#3b7dd8" }
      : { from: "#3b7dd8", to: "#1c4ea8" };
  return (
    <svg
      viewBox="0 0 180 64"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ height, width: "auto" }}
      role="img"
      aria-label="FITO"
    >
      <defs>
        <linearGradient id={gradId} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor={stops.from} />
          <stop offset="100%" stopColor={stops.to} />
        </linearGradient>
      </defs>
      <text
        x="0"
        y="52"
        fontFamily="'Arial Black','Helvetica Neue','Pretendard',system-ui,sans-serif"
        fontSize="58"
        fontWeight="900"
        fontStyle="italic"
        fill={`url(#${gradId})`}
        letterSpacing="-3"
      >
        FiTO
      </text>
    </svg>
  );
}
